import { PROFILE, MEMBERS } from '@core/links/members';

export const isProfilePath = (path: string): boolean => path.indexOf(PROFILE) > -1;
export const isMemberPath = (path: string): boolean => path.indexOf(MEMBERS) > -1;
